import { HomePage } from './../../home/home';
import { PagesProvider } from './../../../providers/pages-provider';
import { Component } from '@angular/core';
import {   NavController, NavParams } from 'ionic-angular';
import { GirisPage } from '../../giris/giris';


@Component({
  selector: 'page-fatura-ana-sayfa',
  templateUrl: 'fatura-ana-sayfa.html',
})
export class FaturaAnaSayfaPage {
  menuler=[];
  gunSonu=false;
  constructor(public navCtrl: NavController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.MenuleriGoruntule();
  }
  menuItemClick(item) {
    
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.PAGE_COMPONENT];
    else
      component = item.PAGE_COMPONENT;
    if (component == GirisPage) {
    //  this.ortak.storeagePersonelCikar();
    }
    this.navCtrl.push(component);
  }
  MenuleriGoruntule() {
    var pagesProvider = new PagesProvider();
    pagesProvider.menuler().then(a => {
      var sonuc = <any>a;
      
        this.menuler = sonuc.FATURA_MENU;
      })
    
  }
  home()
  {
    this.navCtrl.setRoot(HomePage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/faturaislemleri/fatura-ana-sayfa/fatura-ana-sayfa.ts